import { useAppTranslations } from '@treneo/shared/i18n';
import { Button, BUTTON_COLORS, BUTTON_VARIANTS, Typography } from '@treneo/shared/ui';

import { FormContainer } from '../styled';

type Props = {
  error: string;
  onRetry: () => void;
};

export const ErrorDisplay = ({ error, onRetry }: Readonly<Props>) => {
  const { t } = useAppTranslations();

  return (
    <FormContainer>
      <div
        style={{
          color: 'red',
          padding: '20px',
          textAlign: 'center',
          border: '1px solid #ffebee',
          borderRadius: '8px',
          backgroundColor: '#ffebee'
        }}
      >
        <Typography variant='h6' color='error' gutterBottom>
          {t('courseForm.errorLoadingOptions')}
        </Typography>

        <Typography variant='body2' color='error'>
          {error}
        </Typography>

        <Button
          variant={BUTTON_VARIANTS.outlined}
          color={BUTTON_COLORS.primary}
          style={{ marginTop: '16px' }}
          onClick={onRetry}
        >
          {t('common.retry')}
        </Button>
      </div>
    </FormContainer>
  );
};
